<template>
    <div>
        <button @click="addToCart" class="btn btn-primary btn-sm" style="padding: 5px 20px 6px; font-size: 12px;" type="button">
            <i v-show="!adding" class="ion-android-cart" style="padding-right: 5px;"></i>
            <i v-show="adding" class="fa fa-spinner fa-spin" style="padding-right: 5px;"></i>
            Añadir
        </button>
    </div>
</template>

<script>
export default {
    props: {
        product: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            qty: 1,
            adding: false,
        };
    },

    methods: {
        addToCart() {
            this.adding = true;
            this.$inertia.post('/cart', {
                product_id: this.product.id,
                qty: this.qty,
            },
            {
                preserveState: false,
                preserveScroll: true,
            })
            .then(response => {
                this.adding = false;
                toastr.success('Producto añadido al carrito', '¡Listo!');
            })
        },
    },
}
</script>
